import React, { useRef } from 'react';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router';
import DropDown from '../../../../../../../components/DropDown';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import FerpaButton from '../../../../../../../components/FERPA/FerpaComponent';
import { selectFerpaState } from '../../../../../../../features/authentication/authSlice';
import { useSelector } from 'react-redux';

const Header = ({
  classList,
  exportHandler,
  printHandler,
  details,
  isPdfGenerating,
  headerOptions,
  classChangeHandler,
  selectedClassId,
  retryCreditName,
  isLoading,
  isAllStudentReport,
  isAllTeacherReport,
  studentName,
  timePeriod,
  selectedClassName,
  selectedQuestionsCategory
}) => {
  const navigate = useNavigate();
  const ferpaEnabled = useSelector(selectFerpaState);
  const ferpaRef = useRef(null);

  const getClassName = (id) => {
    if (selectedClassName)
      return selectedClassName;
    id = parseInt(id);
    const foundItem = classList.find((item) => item.id === id);
    if (foundItem) {
      return foundItem.name;
    } else {
      return '';
    }
  };

  const getSelectedQuestionCategory = () =>{
    switch(selectedQuestionsCategory){
      case 0: return 'Assigned';
      case 1: return 'Self-Generated';
      case 2: return 'All';
    }
  };

  const handlePrint = () => {
    ferpaRef?.current?.setPopupState(false);
    printHandler();
  };

  return (
    <>
      <div className="student_response_header">
        <div>
          <h3>{headerOptions.reportTitle}</h3>
        </div>
        <div className="d-flex gap-3 justify-content-between align-items-center">
          <FerpaButton ref={ferpaRef} />
          <button id="back_button" onClick={() => navigate(-1)} className="btn btn-width btn-castleWhite">
            Back
          </button>
          <button
            onClick={exportHandler}
            id="export_button"
            className="btn btn-castleOrange"
            disabled={details === null || !details?.studentResults}>
            Export
          </button>
          <button
            onClick={() => handlePrint()}
            id="print_button"
            className={`btn btn-castleRed ${isPdfGenerating ? 'disabled' : ''}`}
            disabled={details === null || !details?.studentResults}>
            {isPdfGenerating ? 'Generating PDF...' : 'Print to PDF'}
          </button>
        </div>
      </div>

      {headerOptions.showClassDropdown &&
        <div className="d-flex flex-column justify-content-start" style={{ width: '30%' }}>
          <DropDown
            value={classList}
            label="Class"
            selectedValue={selectedClassId}
            onChangeHandler={classChangeHandler}
            dropDownId="classDropDown" />
        </div>}
      <div className="student_response_details">
        {isLoading ?
          (
            <div className="d-flex justify-content-between">
              <div className="student_response_details_left" style={{ minWidth: '15%' }}>
                {<p className='w-100'><Skeleton /></p>}
                {<p className='w-100'><Skeleton /></p>}
                {<p className='w-100'><Skeleton /></p>}
                {/* {isAllTeacherReport && <p className='w-100'><Skeleton /></p>} */}
              </div>
              <div className="student_response_details_right" style={{ minWidth: '15%' }}>
                {headerOptions.showStudentName && <p className='w-100'><Skeleton /></p>}
                {headerOptions.showClassName && <p className='w-100'><Skeleton /></p>}
                {headerOptions.showRetryInfo && <p className='w-100'><Skeleton /></p>}
                {headerOptions.showTeacherName && <p className='w-100'><Skeleton /></p>}
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-between">
              <div className="student_response_details_left">
                {headerOptions.showReportType &&
                  <p>
                    {headerOptions.reportType}:
                    <strong className='ms-2'>
                      {details?.assignment}
                    </strong>
                  </p>
                }
                <p>
                  Course:{' '}
                  <strong className='ms-2'>
                    {details?.course}
                  </strong>
                </p>
                {details?.reportDate &&
                  <p>
                    Report Date:{' '}
                    <strong>
                      {details?.reportDate.replace(/\//g, '-')}
                    </strong>
                  </p>}
                {isAllTeacherReport &&
                  <p>
                    Time Period:{' '}
                    <strong>
                      {timePeriod}
                    </strong>
                  </p>
                }
              </div>
              <div className="student_response_details_right" style={{ minWidth: isLoading ? '15%' : '' }}>
                {headerOptions.showStudentName &&
                  <p className='d-flex flex-row'>Student:
                    <strong className='ms-2'>
                      {isAllStudentReport ? 'All Students' : `${ferpaEnabled ? studentName ?? details?.studentResults[0]?.name : 'name hidden'}`}
                    </strong>

                    {!isAllStudentReport &&
                      <button
                        id="student-name"
                        className="btn-link primary-link ms-2 "
                        onClick={() => ferpaRef?.current?.setFerpaState(!ferpaEnabled)}>
                        <FontAwesomeIcon icon={ferpaEnabled ? faEyeSlash : faEye} />{' '}
                        {ferpaEnabled ? 'Hide Name' : 'Show Name'}
                      </button>}
                  </p>}
                {headerOptions.showClassName && !isAllStudentReport &&
                  <p>Class:
                    <strong className='ms-2'>{getClassName(selectedClassId)
                      ? getClassName(selectedClassId)
                      : 'All Classes'}
                    </strong>
                  </p>}

                {headerOptions.showRetryInfo &&
                  <p>
                    Correct on Retry Scoring:
                    <strong className='ms-2'>{retryCreditName}</strong>
                  </p>}
                  {headerOptions.showIncludedQuestions &&
                  <p>
                    Questions Included:
                    <strong className='ms-2'>{getSelectedQuestionCategory()}</strong>
                    </p>}
                {headerOptions.showTeacherName && details?.teacher &&
                  <p>
                    Teacher:
                    <strong className='ms-2'>{details?.teacher}</strong>
                  </p>}
              </div>
            </div>
          )}
        {headerOptions.showTotalRow && <>
          <div className="line"></div>
          <div className="d-flex justify-content-between mt-3">
            <div className="student_response_details_left ">
              <p>For the selected school, teacher and class</p>
            </div>
            <div className="d-flex gap-3">
              <div className="d-flex">
                <p className="mb-0">Assigned </p>
                <div className="status text-castleRed">
                  {details?.assignedTo ?? '0'}
                </div>
              </div>
              <div className="d-flex">
                <p className="mb-0">Started </p>
                <div className="status text-castleRed">
                  {details?.startedCount ?? '0'}
                </div>
              </div>
              <div className="d-flex">
                <p className="mb-0">Completed</p>
                <div className="status text-castleRed">
                  {details?.completedCount ?? '0'}
                </div>
              </div>
              <div className="d-flex">
                <p className="mr-3 mb-0">% Completed</p>
                <div className="status green">
                  {details?.completedPercentage !== undefined ? `${Math.round(details?.completedPercentage)}%` : '0%'}
                </div>
              </div>
            </div>
          </div>
        </>}
      </div>
    </>
  );
};

Header.propTypes = {
  classList: PropTypes.array,
  details: PropTypes.object,
  exportHandler: PropTypes.func,
  printHandler: PropTypes.func,
  isPdfGenerating: PropTypes.bool,
  headerOptions: PropTypes.object,
  classChangeHandler: PropTypes.func,
  selectedClassId: PropTypes.number,
  retryCreditName: PropTypes.string,
  isLoading: PropTypes.bool,
  studentName: PropTypes.string,
  selectedClassName: PropTypes.string,
  isAllStudentReport: PropTypes.bool,
  isAllTeacherReport: PropTypes.bool,
  timePeriod: PropTypes.string,
  selectedQuestionsCategory: PropTypes.number
};

export default Header;
